export default "__VITE_ASSET__00b7f425__"